import { render, staticRenderFns } from "./AreaCompletedCollapse.vue?vue&type=template&id=f3d27546"
import script from "./AreaCompletedCollapse.vue?vue&type=script&lang=js"
export * from "./AreaCompletedCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports